import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useRef, useState } from "react";
const PackageChartView = ({ data }: any) => {
  const [options, setOptions] = useState<Highcharts.Options>({});
  const [shouldScroll, setShouldScroll] = useState(false);
  const chartRef = useRef<any>(null);

  useEffect(() => {
    if (!data) return;

    // Enable scroll on mobile with many items
    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
    const tooManyItems = data.items.length > 6;
    if (isMobile && tooManyItems) {
      setShouldScroll(true);
    }

    // Chart colors
    const colors = [
      "#FF2A00",
      "#008048",
      "#35B1E8",
      "#FFA51F",
      "#FEBEC8",
      "#35B1E8",
      "#008044",
      "#35B1E8",
    ];

    // Main series data
    const mainSeriesData = data.items.map((month: any, index: number) => ({
      name: month.Name,
      y: month.Value,
      Total: month.Total,
      drilldown: month.Value > 0 ? month.Name : null,
      color: colors[index % colors.length],
    }));

    // Drilldown data
    const drilldownMonth = data.items.find((item: any) => item.Value > 0)?.Name;

    const drilldownData = [
      {
        id: drilldownMonth,
        name: `${drilldownMonth} Details`,
        data: data.drilldown
          .sort((a: any, b: any) => Number(a.Name) - Number(b.Name))
          .map((day: any) => [`Day ${day.Name}`, day.Value]),
        type: "column",
      },
    ];

    // Final Highcharts options
    const chartOptions: Highcharts.Options = {
      chart: {
        type: "column",
        ...(shouldScroll && {
          scrollablePlotArea: {
            minWidth: data.items.length * 80, // Adjust this if needed
            scrollPositionX: 0,
          },
        }),
        events: {
          render(this: Highcharts.Chart) {
            const title = this.title?.element;
            if (title) {
              let scrollX = this.plotLeft;
              const scrollableBox = (this as any).scrollablePlotBox;
              if (scrollableBox?.x !== undefined) {
                scrollX -= scrollableBox.x;
              }
              title.setAttribute("transform", `translate(${scrollX}, 0)`);
            }
          },
        },
      },
      title: {
        text: "Package",
        style: {
          fontSize: "13px",
        },
      },
      xAxis: {
        type: "category",
        labels: {
          step: 1,
          style: {
            fontSize: "0.9rem",
          },
        },
      },
      yAxis: {
        title: {
          text: "Total Value",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
          },
        },
      },
      tooltip: {
        useHTML: true,
        formatter: function (this: any) {
          return `
            <b>Month:</b> ${this.point.name}<br/>
            <b>Booking:</b> ${this.point.y}<br/>
            <b>Revenue:</b> ${this.point.Total ?? "-"}
          `;
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Months",
          colorByPoint: true,
          data: mainSeriesData,
          type: "column",
        },
      ],
      drilldown: {
        series: drilldownData as Highcharts.SeriesOptionsType[],
      },
    };

    setOptions(chartOptions);
  }, [data]);

  return (
    <div style={{ overflowX: shouldScroll ? "auto" : "visible" }}>
      <div
        style={{
          minWidth: shouldScroll ? `${data.items.length * 80}px` : "100%",
        }}
      >
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          ref={chartRef}
        />
      </div>
    </div>
  );
};

export default PackageChartView;
